import { render, staticRenderFns } from "./InvoicesTable.vue?vue&type=template&id=b067eae2&scoped=true&"
import script from "./InvoicesTable.vue?vue&type=script&lang=ts&"
export * from "./InvoicesTable.vue?vue&type=script&lang=ts&"
import style0 from "./InvoicesTable.vue?vue&type=style&index=0&id=b067eae2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../backups/absys-worktrees/2026-09-12-colomer-web/src/web/AbsysERP.WebApi/ClientApp/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b067eae2",
  null
  
)

export default component.exports